import { render } from "./infoCompletion.vue?vue&type=template&id=58144531"
import script from "./infoCompletion.vue?vue&type=script&lang=js"
export * from "./infoCompletion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__